import { Navigate } from "react-router-dom"
import { jwtDecode } from "jwt-decode"

const isTokenValid = (token) => {
  try {
    const decoded = jwtDecode(token)
    return decoded.exp * 1000 > Date.now()
  } catch {
    return false
  }
}

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("access")
  return token && isTokenValid(token) ? children : <Navigate to="/login" replace />
}

export default PrivateRoute
